import React from "react";

type RowDirection = "row" | "row-reverse";
type JustifyType =
  | "flex-start"
  | "flex-end"
  | "center"
  | "space-between"
  | "space-around"
  | "space-evenly";
type AlignType = "flex-start" | "flex-end" | "center" | "stretch";
interface GridProps {
  children: React.ReactNode;
  direction?: RowDirection;
  justifyContent?: JustifyType;
  alignItems?: AlignType;
  marginBottom?: number;
}

function Row({
  children,
  direction = "row",
  justifyContent = "flex-start",
  alignItems = "flex-start",
  marginBottom = 0,
}: GridProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: direction,
        justifyContent,
        alignItems,
        flexWrap: "nowrap",
        marginBottom,
      }}
    >
      {children}
    </div>
  );
}

export default Row;
